// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type CompetitorPlant,
  type CompetitorPlantWireFormat,
  NewCompetitorPlant,
} from '../CompetitorPlant/CompetitorPlant';

export class Competitor {
  readonly id: string;
  readonly name: string;
  readonly plants: CompetitorPlant[];
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.plants = (data.plants ?? []).map((plants: any) => NewCompetitorPlant(plants));
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): Competitor {
    const zeroValues: ExcludeMethodsDeep<Competitor> = {
      id: NIL_UUID,
      name: '',
      plants: [],
      isArchived: false,
    };
    return new Competitor(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CompetitorWireFormat = {
  id: string;
  name: string;
  plants: CompetitorPlantWireFormat[];
  isArchived: boolean;
};

type NewCompetitorProps = PartialDeep<Competitor, { recurseIntoArrays: true }>;
export const NewCompetitor: (props: NewCompetitorProps) => Competitor = (props) =>
  new Competitor(props);

type NewCompetitorFromWireFormatProps = PartialDeep<
  CompetitorWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCompetitorFromWireFormat: (
  props: NewCompetitorFromWireFormatProps,
) => Competitor = (props) => new Competitor(props);
